<template>
    <div class="or-admin-product-constructor padding-top-50 padding-bottom-50">
        <p class="close hover-pointer hover-yellow" @click="$emit('close')">Закрыть конструктор изделия</p>
        <div class="constructor">
            <div class="item" v-for="(item, i) in options" :key="item.id">
                <or-admin-product-constructor-text v-if="item.component === 'text'" :options="item" @move_up="move_up(i)" @move_down="move_down(i)" @delete_item="delete_item(i)"/>
                <or-admin-product-constructor-image v-if="item.component === 'image'" :options="item" @move_up="move_up(i)" @move_down="move_down(i)" @delete_item="delete_item(i)"/>
                <or-admin-product-constructor-table v-if="item.component === 'table'" :options="item" @move_up="move_up(i)" @move_down="move_down(i)" @delete_item="delete_item(i)"/>
            </div>
        </div>
        <div class="edit-menu">
            <p class="add hover-pointer hover-yellow" @click="add_text">Добавить блок с текстом</p>
            <p class="add hover-pointer hover-yellow" @click="add_image">Добавить блок с изображениями</p>
            <p class="add hover-pointer hover-yellow" @click="add_table">Добавить блок с таблицей</p>
        </div>
    </div>
</template>

<script>
import {mapActions} from 'vuex'
import orAdminProductConstructorText from "./or-admin-product-constructor-text.vue"
import orAdminProductConstructorImage from "./or-admin-product-constructor-image.vue"
import orAdminProductConstructorTable from "./or-admin-product-constructor-table.vue"
export default {
    components: {
        orAdminProductConstructorText,
        orAdminProductConstructorImage,
        orAdminProductConstructorTable
    },
    props: {
        options: Array,
    },
    data() {
        return {
            items: [

            ],
        }
    },
    methods: {
        ...mapActions({addUnsavedPage: 'addUnsavedPage'}),
        delete_item(index) {
            this.options.splice(index, 1)
            this.addUnsavedPage({page: 'products'})
        },
        move_up(index) {
            if (index === 0) return;
            const item = this.options.splice(index, 1)[0];
            this.options.splice(index - 1, 0, item);
            this.addUnsavedPage({page: 'products'})
        },
        move_down(index) {
            if (index === this.options.length - 1) return
            const item = this.options.splice(index, 1)[0];
            this.options.splice(index + 1, 0, item);
            this.addUnsavedPage({page: 'products'})
        },
        add_text() {
            this.options.push({
                component: 'text',
                id: this.options.length + 1,
                style: {
                    textAlign: 'center',
                    fontSize: '14px',
                    fontWeight: 'normal',
                    marginLeft: '50px',
                    marginBottom: '50px',
                    height: 'auto',
                    marginRight: '50px',
                    minHeight: '10px',
                    paddingTop: '0px',
                },
                text: {
                    title: 'Текст',
                    value: 'Введите текст...',
                }
            })
            this.addUnsavedPage({page: 'products'})
        },
        add_image() {
            this.options.push({
                component: 'image',
                id: this.options.length + 1,
                images: [],
                image_default: {
                    id: null,
                    src: null,
                    style: {
                        width: '100px',
                        height: '100px',
                        objectFit: 'cover',
                        objectPosition: 'center',
                        marginLeft: '0px',
                        marginRight: '0px',
                        paddingTop: '0px',
                        marginBottom: '0px'
                    }
                },
                style: {
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginLeft: '50px',
                    marginRight: '50px',
                    height: 'auto',
                    paddingTop: '0px',
                    marginBottom: '50px',
                    minHeight: '20px',
                },
            })
            this.addUnsavedPage({page: 'products'})
        },
        add_table() {
            this.options.push({
                component: 'table',
                id: this.options.length + 1,
                root: true,
                table: true,
                ceils: {
                    columns: [
                        {
                            width: '100px',
                            flex: true,
                        },
                        {
                            width: '100px',
                            flex: true,
                        },
                    ],
                    rows: [
                        {
                            height: '50px',
                            flex: false,
                        },
                        {
                            height: '50px',
                            flex: false,
                        },
                    ],
                },
                columns: [
                    [
                        {
                            text: {
                                title: 'Текст в ячейке',
                                value: '',
                            },
                            child: null,
                            style: {
                                alignItems: 'center',
                                justifyContent: 'center',
                                textAlign: 'center',
                                fontSize: '14px',
                                fontWeight: 'normal',
                                color: '#ffffff',
                            }
                        },
                        {
                            text: {
                                title: 'Текст в ячейке',
                                value: '',
                            },
                            child: null,
                            style: {
                                alignItems: 'center',
                                justifyContent: 'center',
                                textAlign: 'center',
                                fontSize: '14px',
                                fontWeight: 'normal',
                                color: '#ffffff',
                            }
                        },
                    ],
                    [
                        {
                            text: {
                                title: 'Текст в ячейке',
                                value: '',
                            },
                            child: null,
                            style: {
                                alignItems: 'center',
                                justifyContent: 'center',
                                textAlign: 'center',
                                fontSize: '14px',
                                fontWeight: 'normal',
                                color: '#ffffff',
                            }
                        },{
                            text: {
                                title: 'Текст в ячейке',
                                value: '',
                            },
                            child: null,
                            style: {
                                alignItems: 'center',
                                justifyContent: 'center',
                                textAlign: 'center',
                                fontSize: '14px',
                                fontWeight: 'normal',
                                color: '#ffffff',
                            }
                        },
                    ],
                ],
                style: {
                    height: 'auto',
                    marginLeft: '50px',
                    marginRight: '50px',
                    marginBottom: '50px',
                },
            })
            this.addUnsavedPage({page: 'products'})
        }
    }
}
</script>

<style scoped>
    .or-admin-product-constructor {
        position: relative;
        color: white;
        width: 100%;
        min-height: calc(100vh - 220px);
        background-color: #1e1e1e;
        margin-top: -40px;
    }
    .close {
        font-size: 14px;
        line-height: 16px;
        text-align: left;
        margin-left: 50px;
        margin-bottom: 40px;
    }
    .add {
        margin-top: 30px;
        font-size: 14px;
        line-height: 16px;
    }
</style>
